/**
 * Component spinner / loader.
 *
 * If isEmpty prop is true, show a "no results found" message instead of the spinner.
 */
export default function ComponentLoader(props) {
    const isVisible = props.isVisible;
    const isEmpty = props.isEmpty;
    const hideImage = props.hideImage;

    const height = props.height;
    const width = props.width || "25%";
    const emptyText = props.emptyText || "No results found!";

    return (
        <div hidden={!isVisible} className="component-loader-parent" style={{ height }}>
            {isEmpty ? (
                <div
                    className={hideImage ? "component-loader-pagination-end-no-image" : "component-loader-pagination-end"}
                    style={{ width }}>
                    <p>{emptyText}</p>
                </div>
            ) : (
                <div className="component-loader" style={{ width }} alt="Loading..."></div>
            )}
        </div>
    );
}
